var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResolved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3811 9.58329V12.9166C18.3811 15.8333 16.7101 17.0833 14.2036 17.0833H5.84854C3.34203 17.0833 1.67102 15.8333 1.67102 12.9166V7.08329C1.67102 4.16663 3.34203 2.91663 5.84854 2.91663H10.0261",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84851 7.5L8.46364 9.58333C9.32421 10.2667 10.7362 10.2667 11.5968 9.58333",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2756 2.34995L16.5096 2.82494C16.6265 3.05828 16.919 3.27495 17.178 3.32495L17.4955 3.37495C18.4479 3.53328 18.6735 4.23328 17.9884 4.92495L17.696 5.21661C17.5038 5.41661 17.3952 5.79994 17.4537 6.06661L17.4955 6.24162C17.7545 7.39162 17.1446 7.83327 16.142 7.23327L15.9247 7.10828C15.6657 6.95828 15.248 6.95828 14.989 7.10828L14.7717 7.23327C13.7608 7.84161 13.1508 7.39162 13.4182 6.24162L13.46 6.06661C13.5185 5.79994 13.4099 5.41661 13.2177 5.21661L12.9253 4.92495C12.2401 4.23328 12.4657 3.53328 13.4182 3.37495L13.7357 3.32495C13.9864 3.28328 14.2871 3.05828 14.4041 2.82494L14.638 2.34995C15.0892 1.44162 15.8245 1.44162 16.2756 2.34995Z",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolved);
export default __webpack_public_path__ + "static/media/resolved.8bbb861e2671c9c84dae96ed462ed4df.svg";
export { ForwardRef as ReactComponent };